// 


import React from 'react';
import img from './Aboutbackground.jpeg';
import img2 from './team_collab.png';

export default function Sv() {
  return (
    <div
      className="pt-32 min-h-screen w-full text-white flex flex-col items-center px-6 py-12 bg-cover bg-center"
      style={{ backgroundImage: `url(${img})` }}
    >
      {/* Header Section */}
      <div className="w-full max-w-2xl text-center mb-10">
        <h1 className="text-4xl md:text-6xl font-bold text-cyan-300 bg-clip-text" data-aos="fade-up" data-aos-delay="100">
          ABOUT US
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mt-3 " data-aos="fade-up" data-aos-delay="100">
          Empowering Technology, Securing Futures
        </p>
      </div>

      {/* Image Section */}
      <div className="w-full flex justify-center mb-2">
        <img
          src={img2}
          alt="error"
          className="object-contain w-full max-w-xl px-4"
        
        />
      </div>

      {/* Company Title */}
      <h2 className="text-3xl md:text-5xl font-extrabold text-center mt-10 bg-gradient-to-r from-[#00c3ff] to-[#d400ff] bg-clip-text text-transparent mb-6" data-aos="fade-up" data-aos-delay="100">
        Cybredge PRIVATE LIMITED
      </h2>

      {/* Description */}
      <div className="max-w-3xl text-center text-lg md:text-xl leading-relaxed text-gray-300 px-4">
        <p className="mb-6" data-aos="fade-up" data-aos-delay="100">
          Cybredge PRIVATE LIMITED is a technology-driven cybersecurity and IT
          solutions company dedicated to building secure, scalable, and
          future-ready digital systems. We deliver innovative solutions that
          help businesses grow confidently in a secure digital environment.
        </p>

        <p data-aos="fade-up" data-aos-delay="100">
          Our vision is to become a global leader in cybersecurity and digital
          innovation. Our mission is to build secure and smart technology that
          protects businesses and ensures operational excellence.
        </p>
      </div>
    </div>
  )
}
